export enum APPLICATION_HISTORY_FILTER_TYPE {
	ALL = 'ALL',
	COMMENTS = 'COMMENTS',
	STATUSES = 'STATUSES',
	APPEAL = 'APPEAL',
	EXCEPTIONS = 'EXCEPTIONS'
}
